
import React from 'react';
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";
import { useState, useEffect, useCallback, useRef} from "react";
import { Button } from 'react-bootstrap';
import { BackToTopButton } from 'Components/Button';
import ChevronLeft from '@mui/icons-material/ChevronLeft';

function BackToTop ({footerHeight, pageHeight, footerRef, pageRef}) {
    const [bttBottom, setBttBottom] = useState("10px");
    const [isBTTVisible,setIsBTTVisible]= useState(false);
    const bttRef=useRef(0);
    const [isVisibleHeight, setIsVisibleHeight] = useState(false);
    const [fadeClass, setFadeClass] = useState("fade-out");
    const [focusMain, setFocusMain] = useState(false);

/*const bttRef = useCallback((node) => {
    if (!node) {
        return;
    }
    //console.log(node);
    const resizeObserver = new ResizeObserver((entry) => { 
        //console.log(entry[0].target.getBoundingClientRect().x);
        setBttHeight(entry[0].target.getBoundingClientRect().x);
        //console.log(entry[0].target.clientHeight);
        //console.log("resizePageButton");
    });
    resizeObserver.observe(node);
  }, [setBttHeight]);*/

  //const [bttXOffset, setBttXOffset] = useState(0);
    useEffect(() => {
        //console.log(isVisibleHeight);
        if(isVisibleHeight){
            setFadeClass("fade-in");
        }
        else{
            setFadeClass("fade-out");
        }
        
    },[isVisibleHeight])

    const handleBTTButtonVisible = () => {  
        if(window.scrollY > 100) {
            if(isVisibleHeight!=true){
                setIsVisibleHeight(true);
            }
            //setIsBTTVisible(true);
        }
        else{
            if(isVisibleHeight==true){
                setIsVisibleHeight(false);
            }
            //setIsBTTVisible(false);
        }
    }
    window.addEventListener('scroll', handleBTTButtonVisible);

    useEffect(() => {
        if(focusMain==true){
            window.scrollTo({top:0, behavior:'smooth'});
            setIsVisibleHeight(false);
            //document.getElementById("mainContent").scrollIntoView();
            setFocusMain(false);
        }
    }, [focusMain])

    


const handleBTT = () => {
    //console.log(bttRef.current);
    //console.log(main);
    //main.focus();

    //bttRef.current.blur();

    
    
    //bttRef.current.blur();
    //window.focus();
    //console.log(pageRef);
    //console.log(pageRef.current.childNodes);
    //setFocusMain(true);
    //window.focus()
    //pageRef.current.childNodes[3].focus();

    window.scrollTo({top:0, behavior:'smooth'});
    setIsVisibleHeight(false);
}

var iconViewBox = "6.5 7 12 10";

return (
    <div className="btt-button-container">
        {/*isBTTVisible 
            ? */
                <div className="btt-button" ref={bttRef} >
                    <BackToTopButton tabIndex= {isVisibleHeight==true ? 0 : -1} onClick={handleBTT} fadeClass={fadeClass} variant="normal" icon={() => <ChevronLeft viewBox={iconViewBox}></ChevronLeft>} content={"Back To Top"}></BackToTopButton>
                </div>
                
            /*: null*/
            }
    </div>
  );
}

export default BackToTop;
